import { render, staticRenderFns } from "./similarWare.vue?vue&type=template&id=457ad16b&scoped=true&"
import script from "./similarWare.vue?vue&type=script&lang=js&"
export * from "./similarWare.vue?vue&type=script&lang=js&"
import style0 from "./similarWare.vue?vue&type=style&index=0&id=457ad16b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ad16b",
  null
  
)

export default component.exports